import Meta from './Meta'
import { MainLayout } from 'src/layouts'
import { VolumeChart } from './components'
import styles from './styles.module.scss'
import dynamic from 'next/dynamic'
import useWidth from 'src/hooks/useWidth'
import { intl } from 'src/i18n'

const DominanceChart = dynamic(() => import('src/pages/DominanceChart'), {
  ssr: false,
})

export const GlobalCharts = () => {
  const { isMobile } = useWidth()

  const title = intl.t('globalCharts.seo.title')
  const description = intl.t('globalCharts.seo.description')

  const uri = '/charts'

  return (
    <MainLayout description={description} title={title} uri={uri}>
      <Meta />
      <div className={styles.content}>
        <h1 className={styles.title}>{intl.t('globalCharts.title')}</h1>
        <VolumeChart />
        <DominanceChart isMobile={isMobile} isShare={false} />
      </div>
    </MainLayout>
  )
}

export default GlobalCharts
